var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_5546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.08 20.0066C16.7534 20.3333 16.2267 20.3333 15.9 20.0066L10.36 14.4666C10.1 14.2066 10.1 13.7866 10.36 13.5266L15.9 7.98665C16.2267 7.65998 16.7534 7.65998 17.08 7.98665C17.4067 8.31332 17.4067 8.83998 17.08 9.16665L12.2534 14L17.0867 18.8333C17.4067 19.1533 17.4067 19.6866 17.08 20.0066Z",
    fill: "#1E2234"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_5546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 6 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.106930e7d9d73e275559036829525673.svg";
export { ForwardRef as ReactComponent };